import {
  Button,
  Input,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import styles from "./ProductTile.module.css";
import { useState } from "react";
import { BsInfoCircle } from "react-icons/bs";

const ProductTile = ({ item, onAddToBasketClick }) => {
  const name = item.name;
  const price = item.price;
  const unit = item.unit;
  const amountPerUnit = item.amountPerUnit;
  const imgLink = item.imgLink;
  const available = item.available == true;
  const ingredients = item.ingredients || "";
  const allergens = item.allergens || "";

  const [amount, setAmount] = useState(0.5);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const onAmountDecrease = () => {
    if (amount > 0.5) setAmount(amount - 0.5);
  };
  const onAmountIncrease = () => {
    setAmount(amount + 0.5);
  };

  const resetAmount = () => {
    setAmount(0.5);
  };

  const handleInfoOpen = () => {
    setInfoModalOpen(true);
  };

  const handleInfoClose = () => {
    setInfoModalOpen(false);
  };

  return (
    <div className={styles.tile}>
      {!available && <div className={styles.overlay}></div>}
      <div className={styles.imgDiv}>
        <img src={imgLink} alt={name}></img>
      </div>

      <div className={styles.infoPart}>
        <div className={styles.productName}>
          <h3>
            {name}
            <BsInfoCircle
              className={styles.infoIcon}
              onClick={handleInfoOpen}
            />
          </h3>
        </div>
        <div className={styles.price}>
          {available && (
            <h3>
              Cena: {price} zł/{unit}
            </h3>
          )}
          {!available && <h3>Niedostępne</h3>}
        </div>
        <h3>Ilość {amountPerUnit}</h3>
      </div>
      <div className={styles.amountRow}>
        <Button
          onClick={onAmountDecrease}
          variant="contained"
          style={{ backgroundColor: "#2f82f7" }}
          disabled={!available}
        >
          -
        </Button>
        <Input
          id="standard-adornment-weight"
          type="text"
          step={0.5}
          value={amount}
          disabled={!available}
          endAdornment={<InputAdornment position="end">kg</InputAdornment>}
          aria-describedby="standard-weight-helper-text"
          inputProps={{
            "aria-label": "Ilość",
          }}
          className={styles.inputBox}
          size="small"
        />
        <Button
          onClick={onAmountIncrease}
          variant="contained"
          style={{ backgroundColor: "#2f82f7" }}
          disabled={!available}
        >
          +
        </Button>
      </div>
      <div className={styles.addButton}>
        <Button
          style={{
            backgroundColor: "#2f82f7",
            fontFamily: "Playfair Display, serif",
          }}
          variant="contained"
          onClick={() => {
            onAddToBasketClick(amount);
            resetAmount();
          }}
          disabled={!available}
        >
          Dodaj do koszyka
        </Button>
      </div>

      <Dialog open={infoModalOpen} onClose={handleInfoClose}>
        <DialogTitle style={{ fontFamily: "Playfair Display, serif" }}>
          {name}
        </DialogTitle>
        <DialogContent>
          <div style={{ fontFamily: "Playfair Display, serif" }}>
            {ingredients && (
              <div style={{ marginBottom: "1rem" }}>
                <strong>Składniki:</strong>
                <p>{ingredients}</p>
              </div>
            )}
            {allergens && (
              <div style={{ marginBottom: "1rem" }}>
                <strong>Alergeny:</strong>
                <p>{allergens}</p>
              </div>
            )}
            <div
              style={{
                marginTop: "1.5rem",
                fontStyle: "italic",
                fontSize: "0.9rem",
                color: "#555",
              }}
            >
              TERMIN PRZYDATNOŚCI DO SPOŻYCIA. <br></br>
              NALEŻY SPOŻYĆ DO: 48 GODZIN
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleInfoClose}
            style={{
              backgroundColor: "#2f82f7",
              color: "white",
              fontFamily: "Playfair Display, serif",
            }}
          >
            Zamknij
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ProductTile;
